import AssessmentPaper from '@/apps/assessment/components/assessment-paper'
import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import AssessmentPaperPreview from '@/apps/assessment/components/paper-preview'
import AssessmentTarckMixin from '@/apps/assessment/mixins/assessment-track-mixin'
import RouterMixin from '@/apps/assessment/mixins/clazz-router-mixin'
import { assessmentPaperDetail, paperDetail } from '@/apps/assessment/model/api'
import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'

@Component({ components: { BasicLayout, AssessmentPaper, AssessmentPaperPreview } })
export default class AssessmentPaperinfo extends Mixins(RouterMixin, AssessmentTarckMixin) {
  public paper = {}
  public loading = false
  public mounted() {
    if (this.source === 'QUESTION_BANK') {
      this.getLibPaper()
    } else {
      this.getData()
    }
  }
  public get id() {
    return this.$route.query._id
  }
  public get subjectId() {
    return this.$route.query.subject_id
  }
  public get subject() {
    return this.$route.query.subject
  }
  public get info() {
    return this.$route.query.paper
      ? JSON.parse(decodeURIComponent(String(this.$route.query.paper)))
      : ''
  }
  public get source() {
    return this.$route.query.s
  }
  // 定义试卷的来源，精品卷库、我的试卷
  public get sourceName() {
    return this.$route.query.s === 'QUESTION_BANK' ? '精品卷库' : '我的试卷'
  }
  public publish(data) {
    this.trackPublish('去发布', this.sourceName)
    this.$router.push({
      path: '/clazz/publish',
      query: {
        subject: this.subject,
        subject_id: this.subjectId,
        pid: data.paper.old_paper_id,
        s: this.source,
        f: encodeURIComponent(this.sourceName)
      }
    })
  }
  public async getData() {
    this.loading = true
    try {
      const data: any = await assessmentPaperDetail({
        subject_id: String(this.subjectId),
        assessment_paper_record_id: String(this.id)
      })
      this.loading = false
      if (data.success) {
        this.paper = data.data
      } else {
        this.paper = {}
      }
    } catch (e) {
      console.log(e)
    }
  }

  public async getLibPaper() {
    this.loading = true
    try {
      const data: any = await paperDetail({
        subject_id: String(this.subjectId),
        paper_id: this.id
      })

      this.loading = false
      if (data.success) {
        this.paper = data.data
      } else {
        this.paper = {}
      }
    } catch (e) {
      console.log(e)
    }
  }

  // 返回上级页面
  public back(): void {
    this.$router.back()
  }
}
